import { render, staticRenderFns } from "./member-total.vue?vue&type=template&id=5065bd4c&scoped=true"
import script from "./member-total.vue?vue&type=script&lang=js"
export * from "./member-total.vue?vue&type=script&lang=js"
import style0 from "./member-total.vue?vue&type=style&index=0&id=5065bd4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065bd4c",
  null
  
)

export default component.exports